<div class="form-component">
    <h4>
        Ageing Data Worksheets to Import
    </h4>

    <div *ngIf="loading" class="loading-indicator">
        <div class="spinner"></div>
        Loading Excel worksheets... This may take a moment for larger files.
    </div>

    <form #form="ngForm" *ngIf="!loading">
        <div class="worksheets-container">
            <div class="worksheet-item" *ngFor="let selection of worksheetSelection; let i = index">
                <input #checkbox="ngModel" id="checkbox-{{i}}" name="checkbox-{{i}}" type="checkbox" [(ngModel)]="selection.selected" (change)="!selection.selected && (selection.clientAreaId = undefined)" />
                <label for="checkbox-{{i}}">
                    {{ selection.worksheet }}
                </label>

                <select #dropdown="ngModel" id="dropdown-{{i}}" name="dropdown-{{i}}" [(ngModel)]="selection.clientAreaId" (ngModelChange)="onClientAreaSelected(selection, $event)" [disabled]="!selection.selected" [class.invalid]="dropdown.invalid" required>
                    <option [value]="undefined" disabled selected>-- Select Client Area --</option>
                    <option *ngFor="let clientArea of clientAreas" [value]="clientArea.id">
                        {{ clientArea.name }}{{ usedClientAreaIds.has(clientArea.id) ? ' (ageing already imported)' : '' }}
                    </option>
                </select>

                <p class="error-message" *ngIf="selection.selected && dropdown.invalid">
                    *Please select a client area.
                </p>
            </div>
        </div>

        <p class="error-message" *ngIf="!isWorksheetSelected">
            *At least one worksheet must be selected.
        </p>
    </form>
</div>